import { render } from "./OrderAutomaticCheckReason.vue?vue&type=template&id=e58d4a74&scoped=true"
import script from "./OrderAutomaticCheckReason.vue?vue&type=script&lang=js"
export * from "./OrderAutomaticCheckReason.vue?vue&type=script&lang=js"

import "./OrderAutomaticCheckReason.vue?vue&type=style&index=0&id=e58d4a74&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e58d4a74"]])

export default __exports__